import { render, staticRenderFns } from "./HijackNotification.vue?vue&type=template&id=53f93dff&scoped=true"
import script from "./HijackNotification.vue?vue&type=script&lang=ts"
export * from "./HijackNotification.vue?vue&type=script&lang=ts"
import style0 from "./HijackNotification.vue?vue&type=style&index=0&id=53f93dff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f93dff",
  null
  
)

export default component.exports